import React, { useState, useContext, useEffect } from "react";
// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import AddTherapistToAppDayReq from "../../../../Classes/Models/Requests/AddManyToManyReq";
import SearchTherapistsReq from "../../../../Classes/Models/Requests/Users/SearchUser";
import AsyncSelect from "react-select/async";
import { LanguageContext } from "App";
import UsersApi from "../../../../Classes/API/UsersApi";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import "./addtherapist.scss";
const AddTherapistToDay = ({ setIsLoaded, AppDay }) => {
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [TherapistSearch, setTherapistSearch] = useState();
  const [Therapist, setTherapist] = useState({});
  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    const loadInitialOptions = async () => {
      const options = await GetTherapists();
      setDefaultOptions(options || []);
    };
    loadInitialOptions();
  }, []);

  const AddToDay = async () => {
    let addReq = new AddTherapistToAppDayReq();
    addReq.Id1 = AppDay.id;
    addReq.Id2 = Therapist.id;
    console.log(addReq);

    //top right swal alert that says Adding Therapist
    // Swal.fire({
    //   title: "Adding Therapist",
    //   allowOutsideClick: false,
    //   allowEscapeKey: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   }
    // })
    //make it a toast instead of a popup alert in the top right and make it green and say adding therapist, then make it go away when it's done, and if it fails, make it red and say failed to add therapist, and make it go away after 3 seconds, and if it succeeds, make it green and say added therapist, and make it go away after 3 seconds, and if it fails, BUT it's because the therapist is already added, make it yellow and say therapist already added, and make it go away after 3 seconds, AND MOST IMPORTANTLY MAKE IT SUPER DUPER PRETTY
    Swal.fire({
      title: "Adding Therapist",
      icon: "info",
      toast: true,
      position: "top-right",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let res = await AppointmentsApi.AddTherapistToAppointmentDay(addReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Added Therapist",
        icon: "success",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    } else if (res.message == "Therapist Already Added To Day.") {
      Swal.fire({
        title: "Therapist Already Added",
        icon: "warning",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    } else {
      Swal.fire({
        title: res.message,
        icon: "error",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
    if (res.status == "Success") {
      setIsLoaded(false);
    }
  };

  const GetTherapists = async () => {
    let searchReq = new SearchTherapistsReq();
    searchReq.userType = "Therapist";
    searchReq.name = TherapistSearch;

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      // setTypes(res.data.list)
      let optionsArr = [];
      res.data.list.forEach((item) => {
        console.log("Session: ", item);

        optionsArr.push({
          value: item.getTherapist,
          label: item.name,
        });
      });

      return optionsArr;
    }
  };

  return (
    <div className="card-container">
      <div className="col-md-6">
        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
          {translations.appointmentTableaddtherapistcard} &nbsp;
        </MDTypography>

        <MDTypography variant="button" fontWeight="regular" color="text">
          <AsyncSelect
            isClearable={true}
            defaultOptions={defaultOptions}
            loadOptions={GetTherapists}
            onInputChange={setTherapistSearch}
            onChange={(e) => setTherapist(e ? e.value : "")}
            menuPortalTarget={document.body} // Ensures the menu is rendered at the body level
            menuPosition="fixed" // Positions the menu in a fixed manner
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures the dropdown appears on top of other elements
            }}
            placeholder="Select a therapist..."
          />
        </MDTypography>
      </div>
      <div className="col-md-6 mt-4">
        <MDTypography variant="button" fontWeight="regular" color="text">
          <button onClick={() => AddToDay()} className="btn btn-success" disabled={!Therapist}>
            +
          </button>
        </MDTypography>
      </div>
    </div>
  );
};

export default AddTherapistToDay;
